import { VIOLET_700 } from '../../styles/colors';
import { INTER } from '../../styles/fonts';
import styled, { keyframes } from 'styled-components';

// SVG component based on the provided SVG code
export const LoadingSVG: React.FC = () => (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M48.8527 25.5L52 17M48.8527 25.5L41 20M48.8527 25.5C48.4564 22.159 47.2757 19.0585 45.5 16.3877C41.7378 10.7293 35.3044 7 28 7C16.402 7 7 16.402 7 28C7 39.598 16.402 49 28 49C36.3772 49 43.6087 44.0948 46.9791 37"
        stroke="url(#paint0_linear_1445_17314)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="9 9"
      />
      <path
        d="M48.8527 25.5L52 17M48.8527 25.5L41 20M48.8527 25.5C48.4564 22.159 47.2757 19.0584 45.5 16.3877"
        stroke="url(#paint1_linear_1445_17314)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id="paint0_linear_1445_17314" x1="1.50188" y1="12.2895" x2="49.8305" y2="46.4629" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3452FF"/>
          <stop offset="0.56285" stopColor="#AA06E4"/>
          <stop offset="1" stopColor="#E7282D"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1445_17314" x1="39.656" y1="17.5353" x2="50.4962" y2="26.1715" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3452FF"/>
          <stop offset="0.56285" stopColor="#AA06E4"/>
          <stop offset="1" stopColor="#E7282D"/>
        </linearGradient>
      </defs>
    </svg>
  );

  // Animations
  export const rotate = keyframes`
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  `;

  // Styled Components
  export const ModalBackdrop = styled.div<{ $visible: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: ${(props: any) => props.$visible ? 'flex' : 'none'};
    justify-content: center;
    align-items: center;
    z-index: 2000;
  ` as any;

  export const ModalContainer = styled.div`
    background-color: rgba(243, 244, 247, 0.8);
    margin: 0 88px;
    border-radius: 12px;
    overflow: hidden;
    padding: 3vh 4vw;
  ` as any;

  export const ModalContent = styled.div`
    border-radius: 12px;
    gap: 3vh;
    display: flex;
    flex-direction: column;
    align-items: center;
  ` as any;

  export const SpinnerContainer = styled.div`
    animation: ${rotate} 1s linear infinite;
    display: flex;
    justify-content: center;
    align-items: center;
  ` as any;

  export const MessageText = styled.p`
    font-family: ${INTER.regular};
    color: ${VIOLET_700};
    font-size: 13px;
    text-align: center;
    margin: 0 0;
    /* Make text not selectable/copiable */
    user-select: none;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    pointer-events: none; /* Additional protection */
  ` as any;
